<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content>
  <p>{{ data.message | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">{{ "cancel" | translate }}</button>
  <button mat-raised-button [color]="data.confirmColor || 'primary'" [mat-dialog-close]="true">
    {{ (data.confirmLabel || "confirm") | translate }}
  </button>
</mat-dialog-actions>
